// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hRt1","colBig":"styles_colBig__1ecCH","colSmall":"styles_colSmall__hd4-4"};